





import {Component, Prop, Vue, Watch,Emit} from "vue-property-decorator";
import {getOsType} from "@/fit-ui/common/util";

@Component
export default class FitWxPhoneX extends Vue {
  isIphonex = false;
  tryCount=0;
  maxCount=100;
  curHeight=window.innerHeight;
  checkIsIphoneX(){
    // x xs xr innerheight都高过720
    // 有导航栏时会低于720
    return getOsType() === 'iphone' && window.innerHeight > 720;
  }

  @Emit('resize')
  onResize(){
    this.isIphonex = this.checkIsIphoneX();
    return this.isIphonex;
  }



  created(){
    this.onResize();
    this.calculate();
  }

  calculate(){
    if(this.tryCount<this.maxCount){
      this.tryCount++;
      if(this.curHeight>window.innerHeight){
        this.onResize();
      }else{
        window.requestAnimationFrame(this.calculate)
      }
    }
  }


}
